"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureState = void 0;
var networker_1 = require("@idp/networker");
var FeatureState = /** @class */ (function () {
    // Methods
    function FeatureState(config) {
        // default instance of config object
        this.featureConfig = {
            dc: '',
            featureAPIUri: '/msapi/ixp-allocation-manager-service/v1/allocations',
            recog: false,
            targetPath: '/msapi',
            teams: 'bcv',
            userId: 'test-ui-3',
        };
        // Variables
        this.userId = '';
        // response object
        this.respObj = {
            error: 'check user id',
        };
        this.getFeaturesState = this.getFeaturesState.bind(this);
        if (config) {
            // update the defult instance of config object
            this.featureConfig = FeatureState.extend(config, this.featureConfig);
        }
    }
    // default featureConfig and passed config are compared
    // updated instance of featureConfig is used
    // getFeaturesInstanceState is called with the updated featureConfig
    // call actual url
    // send the response promise back to the caller
    // response will depend on usage of actual userId
    FeatureState.extend = function (first, second) {
        var result = {};
        for (var id in first) {
            if (!result.hasOwnProperty(id)) {
                result[id] = first[id];
            }
        }
        for (var id in second) {
            if (!result.hasOwnProperty(id)) {
                result[id] = second[id];
            }
        }
        return result;
    };
    FeatureState.prototype.getFeaturesState = function () {
        var apiURL = this.featureConfig.featureAPIUri;
        // tslint:disable-next-line:no-console
        console.log('the user id :::::> ', this.featureConfig.userId);
        // added check for targetPath
        if (this.featureConfig.targetPath) {
            apiURL += '?targetPath=' + this.featureConfig.targetPath;
        }
        // added check for teams
        if (this.featureConfig.teams) {
            apiURL += '&teams=' + this.featureConfig.teams;
        }
        if (this.featureConfig.userId && this.featureConfig.userId !== '') {
            apiURL += '&user_id=' + this.featureConfig.userId;
            // added check for DC
            if (this.featureConfig.dc && this.featureConfig.dc !== '') {
                apiURL += '&dc=' + this.featureConfig.dc;
            }
        }
        // added check for recognized
        apiURL += '&user_recognized=' + (this.featureConfig.recog ? this.featureConfig.recog : false);
        return new networker_1.Networker().get(apiURL) /* removed this.fetchOptions as param of get */
            .then(function (res) {
            // this.respObj = response;
            return Promise.resolve(res);
        })
            .catch(function (reason) {
            return Promise.reject(reason);
        });
    };
    return FeatureState;
}());
exports.FeatureState = FeatureState;
//# sourceMappingURL=feature-state.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/business-features/FeatureState/feature-state.js
// module id = 1734
// module chunks = 8